module.exports = __webpack_public_path__ + "static/img/fone.cbf2f69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/match/fone.png
// module id = BsJW
// module chunks = 10